import { boot } from "quasar/wrappers";
import { supabase } from "src/boot/supabase";
import { syncUserToSendfox } from "src/boot/sendfox";
import { createConfirmedSignupSync } from "src/modules/newsletter/services/confirmedSignupSync";

export default boot(() => {
  const sync = createConfirmedSignupSync(syncUserToSendfox);
  supabase.auth.onAuthStateChange((event, session) => {
    if (
      ![
        "INITIAL_SESSION",
        "SIGNED_IN",
        "USER_UPDATED",
        "TOKEN_REFRESHED",
      ].includes(event)
    )
      return;
    window.setTimeout(() => {
      sync(session?.user).catch(() => {
        console.warn(
          "Nieuwsbriefkoppeling nog niet afgerond; de server probeert het opnieuw."
        );
      });
    }, 0);
  });
});
